<template>
    <div class="content-warpper">
        <div class="warpper-title">
            <i class="iconfont iconiconfont-kemu-copy"></i>
            二级科目
        </div>
        <div class="padding-sm">
            <div class="flex align-center justify-between margin-bottom-sm">
                <div class="flex align-center condition-warpper">
                    <el-input
                            v-model="keyword"
                            placeholder="请输入科目"
                            class="margin-right-sm"
                    ></el-input>
                    <el-button type="primary" @click="onSearch">
                        <p class="flex align-center font-size">
                            <i class="el-icon-search margin-right-xs"></i>搜索
                        </p>
                    </el-button>
                </div>
                <el-button type="primary" @click="subdialogDialog = true">
                    <p class="flex align-center font-size">
                        <i class="iconfont iconxinzeng margin-right-xs"></i>二级科目
                    </p>
                </el-button>
            </div>
            <div class="table-warpper">
                <el-table
                        :data="noticeList"
                        header-row-class-name="table-header"
                        row-class-name="table-row"
                        alig="center"
                        fit
                        style="width: 100%"
                >
                    <el-table-column label="一级科目">
                        <template slot-scope="scope">
                            <div class="table-item">
                                {{ scope.row.parent_name }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="二级科目">
                        <template slot-scope="scope">
                            <div class="table-item">
                                {{ scope.row.name }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="创建时间">
                        <template slot-scope="scope">
                            <div class="table-item">
                                {{ scope.row.update_time ? scope.row.update_time : scope.row.add_time }}
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <div class="table-operate">
                                <el-button
                                        size="medium"
                                        type="primary"
                                        @click="editItem(scope.row)"
                                >编辑
                                </el-button>
                                <el-button
                                        size="medium"
                                        type="danger"
                                        @click="deleteItem(scope.row.id)"
                                >删除
                                </el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                        v-if="noticeList.length > 0"
                        class="page-all"
                        background
                        @current-change="setPage"
                        :current-page.sync="page"
                        :page-size="limit"
                        layout="prev, pager, next, jumper"
                        :total="total"
                >
                </el-pagination>
            </div>
        </div>
        <subdialog-dialog
                :setId="setId"
                :setItem="setItem"
                :subdialogDialog="subdialogDialog"
                @cancelDialog="cancelDialog"
        />
    </div>
</template>

<script>
    import {examSubject, delExamSub} from "@/api/projectOffice";
    import subdialogDialog from "@/views/projectOffice/page/dialog/secondSubDialog";

    export default {
        name: "SubDialog",
        data() {
            return {
                keyword: "",
                noticeList: [],
                page: 1,
                total: 0,
                limit: 10,
                setId: 0,
                setItem: {},
                subdialogDialog: false
            };
        },
        components: {
            subdialogDialog
        },
        created() {
            this.$emit(
                "setIndex",
                this.$route.path,
                "当前位置：科目管理 > 二级科目",
                false
            );
            this.getList();
        },
        methods: {
            async getList() {
                let _list = await examSubject(
                    this.page,
                    this.limit,
                    2,
                    1
                );
                this.noticeList = _list.data.list;
                this.total = _list.data.count;
            },
            setPage() {
                this.getList();
            },
            editItem(obj) {
                this.setItem = obj;
                this.setId = obj.id;
                this.subdialogDialog = true;
            },
            deleteItem(id) {
                this.$confirm("确定要删除该科目吗？", "温馨提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    cancelButtonClass: "msg-btn",
                    confirmButtonClass: "msg-btn",
                    center: true
                }).then(() => {
                    this.sureDelete(id);
                });
            },
            async sureDelete(id) {
                let _state = await delExamSub(id);
                if (this.noticeList.length === 1 && this.page > 1) {
                    this.page--;
                }
                this.getList();
                this.$message.success(_state.msg);
            },
            cancelDialog(val) {
                if (val) {
                    this.setId = 0;
                    this.setItem = {};
                    this.subdialogDialog = false;
                    if (this.setId) {
                        this.getList();
                    } else {
                        this.page = 1;
                        this.getList();
                    }
                } else {
                    this.setId = 0;
                    this.setItem = {};
                    this.subdialogDialog = false;
                }
            },
            onSearch() {
                this.page = 1;
                this.getList();
            },
        }
    }
</script>

<style scoped lang="scss">

</style>